import React from 'react';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #666;
  font-size: 14px;
  font-weight: 500;
`;

const DropdownField = styled.select`
  width: 90%;
  padding: 10px 12px;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.3s;

  &:focus {
    border-color: #007AFF;
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.25);
  }
`;

const ErrorText = styled.span`
  color: #ff3b30;
  font-size: 12px;
  position: absolute;
  bottom: -20px;
  left: 0;
`;

function MyDropdownWeekdays({ label, error, selectedDay, onChange }) {
  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  return (
    <DropdownWrapper>
      {label && <Label>{label}</Label>}
      <DropdownField value={selectedDay} onChange={onChange} aria-invalid={!!error}>
        {daysOfWeek.map(day => (
          <option key={day} value={day}>{day}</option>
        ))}
      </DropdownField>
      {error && <ErrorText>{error}</ErrorText>}
    </DropdownWrapper>
  );
}

export default MyDropdownWeekdays;
